import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Booking Number and Company Info
  bookingNumber: `Booking Number: `,
  bookingCompany: `Booking Company: `,

  // Lodgelink Information
  lodgelinkName: 'LodgeLink',
  lodgelinkAddress: 'Suite 1000, 440 — 2nd Avenue SW Calgary, Alberta T2P 5E9',
  logelinkPhoneNumber: '1-844-590-5465',
  lodgelinkSupportEmail: 'support@lodgelink.com',
  logelinkWebsiteLabel: 'https://app.lodgelink.com/en',

  // Page SEO
  seoTitle: 'Booking Details - LodgeLink',
  welcome: "Welcome to the 'Organization Booking Details' screen",

  bookingSummary: 'Booking Summary',
  bookedByLabel: 'Booked by',
  confirmationNumberLabel: 'Confirmation Number',
  organizationBookedLabel: 'Booking Company',
  cancelBookingLabel: 'Cancel Booking',
  newBookingButtonLabel: 'Start a new booking',

  requestModalUpdateTitle: 'Update Special Request(s)',
  requestTitle: 'Special Requests',
  requestCopy:
    '<p>While your lodge or hotel will do its best to meet your needs, <strong>special requests cannot be guaranteed</strong>.</p>',
  requestEditButton: 'Update Special Requests',

  message: 'Tell us how we can make your stay more comfortable.',
  helperText: 'ex. Early check-in, late check-out, room on ground floor or away from elevators, non-smoking etc.',

  // Error Messages Client
  errorRequiredField: '{fieldName} is a required field.',
  // Error Messages Server
  errorUnknown: 'Unknown error please try again later.',
  // Form Confirmation
  confirmationHeading: 'Thanks for your message.',
  confirmationCopy: 'We’ll be in contact as soon as possible!',
  // Location
  address: 'Address',

  // PriceBreakdown
  editRoomsText: 'Edit Room Schedules',
  roomsText: '{numRooms} Room(s)',
  guestsText: '{numGuests} Guest(s)',
  bookedRooms: '{numRooms} room(s) - {rate} /per room per night',
  standByRooms: '{numRooms} room(s) (Standby) - {rate} /per room per night',
  roomType: '{type} Room(s)',
  totalNights: '{number} Night(s) Total',
  unassigned: 'Unassigned',
  taxesTextLabel: 'Other taxes and fees',
  priceTextLabel: 'Price Breakdown',
  dateTextLabel: 'Dates',
  propertyRoomsTextLabel: 'Rooms',
  propertyGuestsTextLabel: 'Guests',
  // eslint-disable-next-line no-template-curly-in-string
  averageRatePerNight: 'Average Rate ${averagePrice} ({currency}) / night',

  estimatedTotalTextLabel: 'Estimated Total',
  estimatedTotalCostDisclaimer:
    '<h1>Estimated Total</h1><p>Since a designated Bookings Supervisor can add, remove, or otherwise edit room details prior to a crew’s stay, final amounts may vary.</p>',

  actualTotalTextLabel: 'Total',
  actualTotalCostDisclaimer:
    '<h1>Total</h1><p>Since a designated Bookings Supervisor can add, remove, or otherwise edit room details prior to a crew’s stay, final amounts may vary.</p>',

  // Payment

  paymentDisclaimerPending:
    "* Once your reservation is confirmed, you'll only be charged for the rooms you use, unless you fail to contact the lodge/hotel within its specified cancellation period.",
  paymentDisclaimerEditing:
    "* Once your reservation edits are confirmed, you'll only be charged for the rooms you use, unless you fail to contact the lodge/hotel within its specified cancellation period.",
  paymentDisclaimerConfirmed:
    "* Your reservation is confirmed!  You'll only be charged for the rooms you use, unless you fail to contact the lodge/hotel within its specified cancellation period.",
  paymentDisclaimerCancelled:
    "* Your reservation has been cancelled.  You'll only be charged for the rooms you failed to cancel within the specified cancellation period of the lodge/hotel.",
  paymentDisclaimerInProgress:
    "* Your reservation is in progress!  You'll only be charged for the rooms you use, unless you fail to contact the lodge/hotel within its specified cancellation period.",
  paymentDisclaimerComplete:
    "* Your reservation is complete!  You'll only be charged for the rooms you used, unless you failed to contact the lodge/hotel within its specified cancellation period.",
  paymentDisclaimerExpired:
    "* Your reservation has expired.  You'll only be charged for the rooms you failed to cancel within the specified cancellation period of the lodge/hotel.",

  paymentDisclaimerLink: 'View cancellation policy',
  paymentEditText: 'Change Payment Method',
  paymentCancelError: 'You will not be charged for this reservation.',
  paymentCodeLabel: 'Payment ID : {code} - {organizationName}',
  creditCardLabel: 'Credit Card : {cardNickName} (XXXX-XXXX-XXXX-{lastFourDigits})',

  // Guest List
  editGuestListText: 'Edit Room Assignments',
  editGuestMutationSuccess: 'Booking guest has been successfully updated',
  missingGuestInfoText: 'Please make sure to provide details for all Unknown Guests prior to check-in.',

  // Status Messages
  statusBookingCancelled: 'This booking has been cancelled.',
  statusBookingPending: 'This booking has not yet been confirmed by {propertyName}.',
  statusBookingPendingCustomer: 'Confirmation required. Please review the booking and confirm below.',
  statusBookingExpired: 'This booking at {propertyName} has expired.',
  statusBookingInProgress: 'This booking is currently in progress @ {propertyName}.',
  statusBookingConfirmed: 'This booking has been successfully confirmed by {propertyName}.',
  statusBookingComplete: 'Thank you for staying at {propertyName}.',

  // LL Admin send Email?
  sendEmailTemplateText: 'Send Email',
  // Cancellation Messages
  cancellationDialogTitle: 'Are you sure you want to cancel your booking?',
  cancellationDialogMessage: 'You may be charged a cancellation fee, in accordance with the property rules.',
  cancellationDialogConfirmButtonText: 'Cancel Booking',
  cancellationDialogRejectButtonText: 'Keep Booking',
  cancellationMutationError:
    'An error occurred while attempting to cancel your booking. Please contact a LodgeLink administrator',
  cancellationMutationSuccess: 'Your booking has been successfully cancelled.',

  updateSpecialRequestsError: 'An error occurred updating this bookings special requests.',
  updateSpecialRequestsSuccess: 'Successfully updated special requests for this booking.',

  editBookingError: 'An error occurred while attempting to edit your booking. Please contact a LodgeLink administrator',
  confirmBooking: 'Confirm Booking',
  soldOut: 'Sold Out',
  additionalInformation: 'Additional Information',
  additionInfoHeadingHotelSupplier:
    'By confirming this reservation, you are accepting both the rate disclosed on the booking details page and availability. Please refer to your LodgeLink rate contract or contact us for more details.',
  hotelConfirmationSubheading:
    "If you are not set up with direct billing, please charge the LodgeLink Virtual Credit Card provided in a dedicated email. Contact us if you have issues with payment. Please do not charge the guest. At check out, email all folios to <a href='mailto:folios@lodgelink.com'>folios@lodgelink.com</a>.",
  lodgeConfirmationSubheading:
    "Please note: LodgeLink has a direct bill account with your property. At check out, please email all invoices to <a href='mailto:ap@lodgelink.com'>ap@lodgelink.com</a>.",
  adminConfirmationSubHeading:
    "Please charge the LodgeLink Virtual Credit Card that will be following in a separate email. Contact us if you have issues with payment, please do not charge the guest. At check out please email all folios to <a href='mailto:folios@lodgelink.com'>folios@lodgelink.com</a>",

  endingParaForHotelSupplier:
    "If you have any questions about this booking or are unable to confirm the reservation, please email <a href='mailto:support@lodgelink.com'>support@lodgelink.com</a> or call 1-844-590-5465. We're available 24 hours a day, 7 days a week.",
  endingParaThanksNote: 'Thank you for your partnership as we transform the way companies manage workforce travel.',
  confirmBookingHeading: 'Confirming Booking',
  confirmBookingSubHeading: 'Are you sure you want to confirm this booking?',

  rejectBookingHeading: 'Rejecting Booking',
  rejectBookingSubHeading: 'Please provide a reason for rejection.',

  confirmModalHeadingMessage: 'Confirmed Booking #{bookingNumber}',
  confirmModalMessage: "Please enter the booking details into your organization's booking system.",

  rejectModalHeadingMessage: 'Rejected Booking #{bookingNumber}',
  rejectModalMessage: 'You may navigate away from this page.',
  rejectedAlertBannerMessage:
    'This booking has been rejected by the property. Please wait as we will be in touch shortly to assist you. For immediate service, call 1-844-590-5465.',

  confirmButtonLabel: 'Confirm',
  rejectButtonLabel: 'Reject',

  // for confirmed booking page
  confirmedBookingNumber: `Confirmed Booking #`,
  easyCheckin:
    "For easy check-in and payment, please enter our booking details into your organization's booking system and provide us with your confirmation number(s) for our records.",
  // Form
  heading: 'Confirmed Booking #{bookingNum}',
  subHeading:
    "For easy check-in and payment, please enter our booking details into your organization's booking system and provide us with your confirmation number(s) for our records.",
  inputTitle: 'Confirmation number(s)',
  inputHelp:
    'If you need to add more than one confirmation number, simply add them above, separated by a comma (e.g. CONFA1, CONFA2, etc.)',
  updateConfirmationNumber: 'Update',
  placeHolderConfirmationNumber: 'Optional Confirmation Number(s)',
  confirmationNumberSubHeading: 'Confirmation Number(s)',

  // Toasts
  bookingConfirmedSuccess: 'Booking Successfully Confirmed',
  varCharWarning: 'Confirmation Number(s) Must Be Under 250 Characters',
  confirmationUpdateSuccess: 'Confirmation Number Successfully Updated'
});

export default messages;

export const rejectionReasons = [
  { label: 'Sold Out', value: 'SOLD_OUT' },
  { label: 'Room(s) are not available', value: 'ROOMS_UNAVAILABLE' },
  { label: `Doesn't meet booking restrictions`, value: 'BOOKING_RESTRICTIONS_NOT_MET' },
  { label: 'Blacked Out/Special Event', value: 'BLACKED_OUT' },
  { label: 'Other', value: 'OTHER' }
];
